module.exports = __webpack_public_path__ + "static/img/bingli.516b843.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/docs/bingli.jpg
// module id = sq38
// module chunks = 1